import { useEffect } from "react"

import AuthProvider from "../services/auth/AuthProvider/Index"
import CenteredLoader from "../components/CenteredLoader"

const AuthenticationCallback = () => {
    useEffect(() => {
        (async () => {
            await AuthProvider.login()
        })()

        document.title = 'Signing in...'
    })

    return <CenteredLoader />
}

export default AuthenticationCallback
